/*
* @Description: 提货司机管理编辑弹出层
* @Author: ma.cq
* @Date: 2018-10-18 10:46:50
* @LastEditors: ma.cq
* @LastEditTime: 2018-10-18 10:46:50
*/
<template>
  <el-dialog
    title="编辑" :visible.sync="visible" @close="handleClose"
    width="700px">
    <el-form
      class="form"
      :model="form"
      :rules="rules"
      ref="form"
      :label-width="formLabelWidth"
      :disabled="inBlack">
      <el-form-item label="司机姓名" prop="driverName">
        <el-input
          class="form-input"
          v-model="form.driverName"
          :maxlength="20"
          placeholder="司机姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机" prop="phone">
        <el-input
          class="form-input"
          v-model="form.phone"
          placeholder="请输入手机号"
          ></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="identityCard">
        <el-input
        class="form-input"
        v-model="form.identityCard"
        placeholder="请输入身份证号"
      ></el-input>
      </el-form-item>
      <el-form-item label="信誉值" prop="trustPoint">
        <el-input-number v-model="form.trustPoint" :precision="0" controls-position="right"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import { checkPhone } from '@/common/verify'

export default {
  name: 'editDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: this.show,
      formLabelWidth: '120px',
      form: {
        driverName: '',
        phone: '',
        identityCard: '',
        trustPoint: ''
      },
      rules: {
        driverName: [
          { required: true, message: '请填写司机姓名' }
        ],
        phone: [
          { required: true, message: '请填写手机号' },
          { pattern: checkPhone, message: '格式有误' }
        ],
        identityCard: [
          { required: true, message: '请填写身份证号' },
          { pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X])$)$/, message: '格式有误' }
        ],
        trustPoint: [
          { required: true, message: '请输入信誉值' }
        ]
      },
      inBlack: false
    }
  },
  methods: {
    ...mapActions(['getDriver', 'editDriver']),
    handleSubmit () {
      // 黑名单不可修改
      if (this.inBlack) {
        this.handleClose()
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.editDriver({ ...this.form }).then(() => {
            this.getDriver({ pageNo: 1 })
            this.$message.success('编辑成功')
            this.handleClose()
          })
        } else {
          return false
        }
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = { ...this.formData }
        this.inBlack = this.formData.status === 2
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin: 0 auto;
}

.form-input, .form-select, .el-input-number {
  width: 200px;
}
</style>
